import React, { useEffect, useState, useRef } from 'react';
import Header from '../layout/Header';
import Sidebar from '../layout/Sidebar';
import Footer from '../layout/Footer';
import Breadcrumbs from '../Reusables/Breadcrumbs';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import '../../scss/contact.scss';
import { useDispatch } from 'react-redux';
import { parseBreadcrumbsList } from '../../store/Actions';
import Dropdown from '../../components/Reusables/Dropdown';
import CityStatedropdown from '../../components/Reusables/CityStatedropdown';
import getResponse from '../actions/Project';
import getCommonResponse from '../actions/Common';
import downArrow from '../../images/common/bluedownarrow.png';
import upArrow from '../../images/common/blueuparrow.png';
import getContact from '../actions/Contacts';
import Spinner from '../Reusables/Spinner';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie'
import RefreshToken from '../actions/RefreshToken';
import Snackbars from '../Reusables/Snackbar';
import add from '../../images/projectdetails/add.png';
import AddContact from '../popups/AddContact';
import trash from '../../images/common/trash.png';
import DeleteItem from '../popups/DeleteItem';
import { trim } from '../Reusables/Function';
import { parseNewContactEmail } from '../../store/Actions'
import eyeIcon from '../../images/login/eyeicon.png';
import edit from '../../images/common/edit.png';

const path = window.location.href;  
const pathSplit = path.split('/');
const id = parseInt(pathSplit[pathSplit.length - 2]);
const pageType = pathSplit[pathSplit.length - 1];

let addmoreArray = [], addmorEmail = [];
let emailArr = [], phone = [];
let loop = 1, mail = 1;

function ClickOutside1(ref, setDropdownCliked1) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setDropdownCliked1(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}

function ClickOutside2(ref, setDropdownCliked2) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setDropdownCliked2(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
}

function ClickOutside3(ref, setDropdownCliked3) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setDropdownCliked3(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
}

function ClickOutside4(ref, setDropdownCliked4) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setDropdownCliked4(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
}

function ClickOutside(ref, setDropdownCliked, showTag) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                console.log(event);
                setDropdownCliked(false);
                const element = document.getElementById('dropdown-lists'+showTag)
                console.log(element, showTag)
                // if(element) {
                //     element.style.display = 'none'
                // }
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}

function CreateNewcontact(props) {
    const accessToken =  Cookies.get('access_token');
    const countryCodes = require('country-codes-list');
    var UsaStates = require('usa-states').UsaStates;
    let loops = 3, mails = 1;
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    let dropdownlistcitys = [], dropdownliststates = [];
    const city = "Select City";
    const state = "";    
    const entityId = useSelector((state) => state.id);
    var StoreValue = {};    
    const breadcrumbsList = [
        { "name": "Home", "url": "" },
        { "name": "Contacts", "url": "contacts/list"},
        { "name": "Contacts New", "url": "contacts/new" }
    ];
    const [enable, setEnable] = useState(true);
    const [showEdit, setshow] = useState(false);    
    const [dropdownlistcity, setDropdownlistcity] = useState([]);
    const [dropdownliststate, setDropdownliststate] = useState([]);
    const [entityLabel, setEntityLabel] = useState('Select Property');
    const [cityLabel, setCityLabel] = useState('Select City')
    const [stateLabel, setStateLabel] = useState('')
    const [entityList, setEntityList] = useState([]);
    const [entityid, setEntityId] = useState(null);
    const [saluation, setSaluation] = useState('');
    const [saluationlabel, setSaluationLabel] = useState('');
    const [salutaionList, setSalautionList] = useState([]);
    const [Firstname, SetFname] = useState(null);
    const [Lastname, SetLname] = useState(null);
    const [title, setTitle] = useState(null);
    const [password, setPassword] = useState(null);
    const [franchise, setFranchise] = useState(null);
    const [Address, SetAddress] = useState(null);
    const [cityname, SetCity] = useState('');
    const [statename, SetState] = useState('');
    const [Iso, SetIso] = useState('');
    const [ZipCode, SetZipCode] = useState('');
    const [callingCodes, setCallingCodes] = useState([]);
    const [PhoneNumbers, setPhoneNumbers] = useState([]);
    const countryCallingCodeObject = countryCodes.customList('countryCode', '+{countryCallingCode}');
    const [show, setShow] = useState(false)
    const [label, setLabel] = useState('');
    const [shows, setShows] = useState(false)
    const [labels, setLabels] = useState('')
    const {id} = useParams();
    const [phoneEdit, setPhoneEdit] = useState(false)
    const [emailEdit, setEmailEdit] = useState(false)
    const [cityCode, setCityCode] = useState('')
    const [isCode, setIsCode] = useState(false)
    const [Code, setCode] = useState(false)
    const [save, setSave] = useState(false)
    const [relation, setRelation] = useState('')
    const [emailID1, setEmailID1] = useState(null)
    const [emailID2, setEmailID2] = useState(null)
    const [emailID3, setEmailID3] = useState(null)
    const [phone1, setPhone1] = useState(null)
    const [phone2, setPhone2] = useState(null)
    const [phone3, setPhone3] = useState(null)
    const [countryCode1, setCountry1] = useState('+1')
    const [countryCode2, setCountry2] = useState('+1')
    const [countryCode3, setCountry3] = useState('+1')
    const [fname, SetFirstname] = useState('')
    const [lname, SetLastname] = useState('')
    const [open, setOpen] = useState(null)
    const [showTag, setShowTag] = useState('')
    const [infoData, setInfoData] = useState(null);
    const [phoneTrigger, setPhoneTrigger] = useState(null)
    const [emailTrigger, setemailTrigger] = useState(null)
    const {setShowView} = props;
    const [showContacts, setShowContacts] = useState(false);
    const [propertyDetails, setPropertyDetails] = useState([]);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deletedPropertyIndex, setDeletedPropertyIndex] = useState(null);
    const [toggle, setToggle] = useState(false);
    const [brandLabel, setBrandLabel] = useState('Select Portal');
    const [brandList, setBrandList] = useState([]);
    const [brandId, setBrandId] = useState(null);
    const [selectedEntityList, setSelectedEntityList] = useState([]);
    const [showPassword, setShowPassword] = useState(false);
    const [callingCodeSuggestions, setCallingCodeSuggestions] = useState([]);

    const [entityDetails, setEntityDetails] = useState({idContactsEntityRelation: 0, idEntities: null, name: "", relationship: null});
    const [propertyLabel, setPropertyLabel] = useState("Select Property");
    const [error, setError] = useState("");

    const [values, setValues] = useState({
        countryDropdownClick: false,
        countryCodeDropdownClick: false,
        countryDropdownClick1: false,
        // countryCodeDropdownClick1: false,
        countryDropdownClick2: false,
        // countryCodeDropdownClick2: false,
        countryDropdownClick3: false,
        // countryCodeDropdownClick3: false,
        cityDropdownClick3: false,
        emailId: "",
        phoneNumber: '',
        phone: '',
        countryCodes: " ",
        PrimaryEntityId: null,
        Emails: null,
        PhoneNumbers: null,
        selected: [],
        countryCoding: "Select City",
    })  
    const tableHeaders = [
        { "name": "Property", "sort": false, "width": "200px" },
        { "name": "Relationship", "sort": false, "width": "200px" },
        { "name": "Action", "sort": false, "width": "100px" }
    ];

    const handleCloseDeletePropertyPopup = () => {
        setShowDeletePopup(false);
    }

    const handleShowDeletePropertyPopup = () => {
        setShowDeletePopup(true);
    }

    const dropdownwrapperRef1 = useRef(null);
    const [countryCodeDropdownClick1, setDropdownCliked1] = useState(false);
    ClickOutside1(dropdownwrapperRef1, setDropdownCliked1);

    const dropdownwrapperRef2 = useRef(null);
    const [countryCodeDropdownClick2, setDropdownCliked2] = useState(false);
    ClickOutside2(dropdownwrapperRef2, setDropdownCliked2);

    const dropdownwrapperRef3 = useRef(null);
    const [countryCodeDropdownClick3, setDropdownCliked3] = useState(false);
    ClickOutside3(dropdownwrapperRef3, setDropdownCliked3);

    const dropdownwrapperRef4 = useRef(null);
    const [countryCodeDropdownClick4, setDropdownCliked4] = useState(false);
    ClickOutside4(dropdownwrapperRef4, setDropdownCliked4);
    
    const dropdownwrapperRef = useRef(null);
    const [countryCodeDropdownClick, setDropdownCliked] = useState(false);
    ClickOutside(dropdownwrapperRef, setDropdownCliked, showTag);

    // function GetDropdowncity() { 
    //     const countryCode = 'US';
    //     const citys = City.getCitiesOfCountry(countryCode);
    //     dropdownlistcitys = citys;
    //     setDropdownlistcity(citys);
    // }

    const handleCloseContacts = () => {
        setShowContacts(false);
    }

    const handleProperties = (type, data = null) => {
        // setToggle(!toggle);
        setShowContacts(true);
        setError("");
        if(type == "add") {
            setPropertyLabel("Select Property");
            setEntityDetails({idContactsEntityRelation: 0, idEntities: null, name: "", relationship: null});
        } else {
            console.log("Selected data ", data);
            setPropertyLabel(data.name);
            setEntityDetails({
                idContactsEntityRelation: data.idContactsEntityRelation, 
                idEntities: data.idEntities, 
                name: data.name, 
                relationship: data.relationship
            });
        }
    }

    function GetDropdownstate() { 
        var usStates = new UsaStates({includeTerritories: false});
        var statesNames = usStates.arrayOf('abbreviation');
        setDropdownliststate(statesNames);
    }

    function add_fields() {
        setLabel(loop);
        console.log(loop);
        addmoreArray.push(loop);
        loop =loop+1;
        setShow(!show);
    }
    function add_more() {
        setLabels(mail);
        addmorEmail.push(mail);
        console.log("[MORE]", addmorEmail);
        mail++;
        setShows(!shows);
    }
    function GetDropdown() {

        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                getCommonResponse.GetDetailsWithToken('/api/brand/dropdown?parent=true', accesstoken, (data) => {
                    if(data.status == 200) {
                        var brandArray = [];
                        data.data.data != null && data.data.data.length > 0 && data.data.data.map((item) => {
                            const brandObject = {id: 0, name: ''}
                            brandObject.id = item["idBrand"];
                            brandObject.name = item["name"];
                            brandArray.push(brandObject);
                        })
                        setBrandList(brandArray);

                        const endpoint = "/api/entity/dropdown";
                        getResponse.GetEntityDropdown(accesstoken, endpoint, (response) => { 
                            if(response.status == 200) {
                                setEntityList(response.data.data);
                            } else if(response.status == 401) {
                                navigate("/login")
                            }    
                        });
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                })
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    function getSaluatiion() {
        const salutation = [
            {
                "id": 1,
                "name": "Mr"
            },
            {
                "id": 2,
                "name": "Mrs"
            },
            {
                "id": 3,
                "name": "Miss"
            },
        ]
        setSalautionList(salutation);
        
    }
    function handleFname(value) {
        SetFname(value)
    }
    function handleLname(value) {
        SetLname(value)
    }
    function handleTitle(value) {
        setTitle(value);
    }
    function handlePassword(value) {
        setPassword(value);
    }
    function handleFranchise(value) {
        setFranchise(value);
    }
    function handleRelationship(value) {
        setRelation(value);
    }
    function handlAddress(value) {
        SetAddress(value)
    }
    function handlZipcode(value) {
        SetZipCode(value)
    }
    function handleCity(value) {
        SetCity(value);
    }
    function changeEmail1(value) {
        setEmailID1(value)
    }
    function changeEmail2(value) {
        setEmailID2(value)
    }
    function changeEmail3(value) {
        setEmailID3(value)
    }
    function setPhoneNumbers1(value) {
        setPhone1(value)
    }
    function setPhoneNumbers2(value) {
        setPhone2(value)
    }
    function setPhoneNumbers3(value) {
        setPhone3(value)
    }
    function setPhoneNumber(value, index) {
        let label = document.getElementById('dropdown-input'+index)
        if(label) {
            label.innerText = value
        }
    }
    const handleCountryCodeDropdown = (id) => {
        setShowTag(id);
        console.log(id);
        let element = document.getElementById('dropdown-lists'+id);
        let image = document.getElementById('dropdown-image'+id);
        if(element.style.display == 'none') {
            element.style.display = 'block';
            image.src = upArrow
        } else  {
            element.style.display = 'none';
            image.src = downArrow
        }
    }
    const getCountryCode = (e, index) => {
        setValues({
            ...values,
            countryCodes: e.target.innerText
        })
        let label = document.getElementById('dropdown-label'+index)
        let image = document.getElementById('dropdown-image'+index);
        console.log("label")
        if(label) {
            label.innerText = e.target.innerText
            console.log(label.innerText, e.target.innerText)
        }
        let element = document.getElementById('dropdown-lists'+index)
        if(element) {
            element.style.display = 'none';
            image.src = downArrow;
        }
    }
    function changeEmail(value,index) {
        let emailLabel = document.getElementById('email-input'+index);
        console.log(emailLabel.innerText)
        if(emailLabel) {
            emailLabel.innerText = value
        }
        // setValues({
        //     ...values,
        //     emailId: value
        // })
    }
    const handleCountryCodeDropdown1 = () => {
        setDropdownCliked1(!countryCodeDropdownClick1)
    }
    const getCountryCode1 = (value) => {
        setCountry1(value)
        getCallingCodeSuggestions(value);
        setDropdownCliked1(true)
    }
    const getCountryCode1FromSelection = (value) => {
        setCountry1(value)
        setDropdownCliked1(false)
    }
    const getCallingCodeSuggestions = (value) => {
        let suggestions = [];
        if(value != "") {
            callingCodes.length > 0 && callingCodes.map((item) => {
                if(item.includes(value)) {
                    suggestions.push(item)
                }
            })
        }
        setCallingCodeSuggestions(suggestions);
    }
    const handleCountryCodeDropdown2 = () => {
        setDropdownCliked2(!countryCodeDropdownClick2)
    }
    const getCountryCode2 = (value) => {
        setCountry2(value)
        getCallingCodeSuggestions(value);
        setDropdownCliked2(true)
    }
    const getCountryCode2FromSelection = (value) => {
        setCountry2(value)
        setDropdownCliked2(false)
    }
    const handleCountryCodeDropdown3= () => {
        setDropdownCliked3(!countryCodeDropdownClick3)
    }
    const getCountryCode3 = (value) => {
        setCountry3(value)
        getCallingCodeSuggestions(value);
        setDropdownCliked3(true)
    }
    const getCountryCode3FromSelection = (value) => {
        setCountry3(value)
        setDropdownCliked3(false)
    }
    const getCountryCodeArray = () => {
        const countryCallingCodeArray = [];
        Object.keys(countryCallingCodeObject).forEach((key) => {
            if(!countryCallingCodeArray.includes(countryCallingCodeObject[key])) {
                countryCallingCodeArray.push(countryCallingCodeObject[key].replace(/ /g, ''));
            }
        });
        setCallingCodes(countryCallingCodeArray.sort());
    }
    function getPhonenum() {
        phone = []; let obj = {};
        if(countryCode1 != null && countryCode1 != '' && phone1 != null && phone1 != '' ) {
            var obj1 = {
                CountryCode: countryCode1,
                PhoneNumber: trim(phone1)
            }
            phone.push(obj1)
        }
        if(countryCode2 != null  && phone2 != null && countryCode2 != '' && phone2 != '') {
            var obj2 = {
                CountryCode: countryCode2,
                PhoneNumber: trim(phone2)
            }
            phone.push(obj2)
        }
        if(countryCode3 != null && countryCode3 != '' && phone3 != null && phone3 != '') {
            var obj3 = {
                CountryCode: countryCode3,
                PhoneNumber: trim(phone3)
            }
            phone.push(obj3)
        }
        console.log(addmoreArray)
        for(let i = 0; i <= addmoreArray.length; i++) {
            let element = document.getElementById('dropdown-label'+i)
            let code = document.getElementById('dropdown-input'+i);
            if(element && code && element.innerText != '' && code.value != '') {
                console.log(element.innerText, code.value)
                obj = {
                    CountryCode: element.innerText,
                    PhoneNumber: trim(code.value)
                }
                phone.push(obj)
            }
        }
        // return phone
    }
    function getEmail() {
        emailArr = [];
        console.log("Mail count", addmorEmail);
        if(emailID1) {
            emailArr.push(trim(emailID1))
        }
        if(emailID2) {
            emailArr.push(trim(emailID2))
        }
        if(emailID3) {  
            emailArr.push(trim(emailID3))
        }
        for(let i = 0; i <= addmorEmail.length; i++) {
            let code = document.getElementById('email-input'+i);
            if(code) {
                var emailId = code.value
                emailArr.push(trim(emailId))
            }
        }
        // return emailArr

    }
    function onSave() {
        var path = window.location.href;
        var pathSplit = path.split('/');        
        var pageType = pathSplit[pathSplit.length - 1];
        console.log('pageType', pageType);
        setEnable(false);
        getEmail()
        getPhonenum()
        let labeling = document.getElementsByClassName('dropdown-label-code')
        const details = {
            FirstName: Firstname ? trim(Firstname): null,
            LastName: Lastname ? trim(Lastname) : null,
            Salutation: saluation ? saluation: null,
            Address: Address ? trim(Address): null,
            City: cityname ? trim(cityname) : null,
            State: statename ? trim(statename) : null,
            ZipCode: ZipCode ? trim(ZipCode): null,
            PrimaryEntityId: null,
            Emails: emailArr,
            PhoneNumbers: phone,
            Relationship: null,
            Entities: propertyDetails,
            Title: title ? trim(title) : null,
            Franchise: franchise ? trim(franchise) : null,
            BrandId: brandId,
            Password: password ? trim(password) : null
        }
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                console.log(StoreValue)
                if(pageType == "new") {
                    console.log("create-project")           
                    getContact.AddContact(details,'/api/contacts/add', accesstoken, (data) => {
                        setEnable(true);
                        if(data.status == 200) {
                            if(data.data.cmsUserId != null && data.data.cmsUserId != 0) {
                                dispatch(parseNewContactEmail(emailArr[0]));
                            }
                            addmoreArray = []; addmorEmail = [];
                            emailArr = []
                            phone = []
                            loop = 1 
                            mail = 1        
                            navigate(`/contacts/list`)
                        }
                        else if(data.status == 400) {
                            console.log(data)
                            setOpen(true)
                            setErrorMessage(data.data.message);
                            setLoading(false);
                        } else if(data.status == 401) {
                            navigate("/login")
                        }

                    })
                } else {
                    Callupdate();
                } 
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));   
    }
    const Callupdate = () => {
        getEmail()
        getPhonenum()
        let labeling = document.getElementsByClassName('dropdown-label-code')
        const details = {
            ContactId: id ? id: null,
            FirstName: Firstname ? trim(Firstname) : null,
            LastName: Lastname ? trim(Lastname) : null,
            Salutation: saluation ? saluation : null,
            Address: Address ? trim(Address) : null,
            City: cityname ? trim(cityname) : null,
            State: statename ? trim(statename) : null,
            ZipCode: ZipCode ? trim(ZipCode) : null,
            PrimaryEntityId: entityid ? entityid : null,
            Emails: emailArr,
            PhoneNumbers: phone,
            Relationship: relation ? relation : null,
            Entities: propertyDetails,
            Title: title ? trim(title) : null,
            Franchise: franchise ? trim(franchise) : null,
            BrandId: brandId,
            Password: password ? trim(password) : null
        }
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getContact.Updatecontact(details,'/api/contacts/update', accesstoken, (data) => {
                    setEnable(true);
                    console.log(data)
                    if(data.status == 200) {
                        emailArr = []
                        phone = [];
                        addmoreArray = []; addmorEmail = [];
                        loop = 1 
                        mail = 1 
                        const path = window.location.href;
                        const pathSplit = path.split('/');        
                        const pageType = pathSplit[pathSplit.length - 1];
                        if(pageType == "edit") {
                            setLoading(true)
                            navigate(`/contacts/list`)              
                        } 
                        else if(pageType == "view") {
                            setLoading(true)
                            const id = parseInt(pathSplit[pathSplit.length - 2]);
                            navigate(`/contacts/${id}/view`);
                            let ShowView = true
                            setshow(true)
                            setShowView(ShowView);               
                        } 
                    }
                    else if(data.status == 400 ) {
                        setOpen(true)
                        setErrorMessage(data.data.message);
                        setLoading(false)
                    } else if(data.status == 401) {
                        navigate("/login")
                    }

                })
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));

    }

    const Additionalattri = (data) => {
        addmoreArray = []; addmorEmail = [];
        const phonenum = data.phoneNumbers;
        const emailIds = data.emails;
        console.log(emailIds.length)
        let phoneEdits = 1, emailEdits = 1, labels = 1; var mailLabel = 1 ;
        for(let i = 3; i <=  phonenum.length; i++ ) {
            if(i < phonenum.length) { 
                addmoreArray.push(phoneEdits);
                phoneEdits++;
                setPhoneEdit(!phoneEdit)
            } else {
                setPhoneTrigger(true)
            }
        }
        for(let k = 3; k <= emailIds.length; k++) {
            if(k < emailIds.length) { 
                addmorEmail.push(emailEdits);
                emailEdits++;
                setEmailEdit(!emailEdit)
            } else {
                setemailTrigger(true)
            }
        }
        console.log(addmorEmail)
        for(let i = 3;i <= phonenum.length; i++) {
            let label = document.getElementById('dropdown-label'+labels)
            let code = document.getElementById('dropdown-input'+labels);
            if(label && code ) {
                label.innerText = phonenum[i].countryCode;
                code.value = phonenum[i].phoneNumber;
                labels++;
            }
        }
        console.log(emailIds)
        var emailId = emailIds;
        for(let j = 3; j <= emailIds.length; j++) {
            var mail = document.getElementById('email-input'+mailLabel);
            mail.value = emailId[j];
            mailLabel++;  
            console.log(mailLabel)  
        }
        let labeling = document.getElementsByClassName('dropdown-label-code')[0];
        console.log("Select City", data.city, labeling)
        if(labeling && data.city) {
            console.log("Select City",data.city, labeling)
            labeling.innerText = data.city
        }
    }

    useEffect(() => {
        infoData && infoData != null && Additionalattri(infoData)
    },[phoneTrigger, emailTrigger])

    const detailsApi = (data) => {
        console.log("Contacts List", data);
        // setRelation(data.relationship && data.relationship)
        setPropertyDetails(data.entities && data.entities);
        SetFname(data.firstName && data.firstName);
        SetLname(data.lastName && data.lastName);
        setTitle(data.title && data.title);
        setFranchise(data.franchise && data.franchise);
        setBrandLabel(data.brand && data.brand.name);
        setBrandId(data.brand && data.brand.idBrand);
        SetAddress(data.address && data.address);
        // setEntityId(data.entity.idEntities && data.entity.idEntities);
        // setEntityLabel(data.entity.entityName && data.entity.entityName);
        SetCity(data.city && data.city);
        setCityLabel(data.city && data.city);
        SetState(data.state && data.state);
        setSaluation(data.salutation && data.salutation);
        setSaluationLabel(data.salutation && data.salutation);
        data.state ? setStateLabel(data.state && data.state) :  setStateLabel("");
        data.zipCode ? SetZipCode(data.zipCode && data.zipCode) : SetZipCode('');
        setEmailID1(data.emails[0] && data.emails[0]);
        setEmailID2(data.emails[1] && data.emails[1]);
        setEmailID3(data.emails[2] && data.emails[2]);
        setPhone1(data.phoneNumbers[0] && data.phoneNumbers[0].phoneNumber && data.phoneNumbers[0].phoneNumber);
        setPhone2(data.phoneNumbers[1] && data.phoneNumbers[1].phoneNumber && data.phoneNumbers[1].phoneNumber);
        setPhone3(data.phoneNumbers[2] && data.phoneNumbers[2].phoneNumber && data.phoneNumbers[2].phoneNumber);
        data.phoneNumbers[0] ? (data.phoneNumbers[0].countryCode ? setCountry1(data.phoneNumbers[0].countryCode) : setCountry1("+1")) : setCountry1("+1");
        data.phoneNumbers[1] ? (data.phoneNumbers[1].countryCode ? setCountry2(data.phoneNumbers[1].countryCode) : setCountry2("+1")) : setCountry2("+1");
        data.phoneNumbers[2] ? (data.phoneNumbers[2].countryCode ? setCountry3(data.phoneNumbers[2].countryCode) : setCountry3("+1")) : setCountry3("+1");
        Additionalattri(data);
        setInfoData(data);
    }
    const getBreadcrumbs = () => {
        var breadcrumbsList = [];
        if(StoreValue.page == "create-project") {
            breadcrumbsList = [
                { "name": "Home", "url": "" },
                { "name": "Contacts", "url": "contacts/list" },
                { "name": "Contacts New", "url": "contacts/new" }
            ];
        } else if (StoreValue.page == "edit-project") {            
            breadcrumbsList = [
                { "name": "Home", "url": "" },
                { "name": "Contacts", "url": "contacts/list" },
                { "name": `Contact: Edit`, "url": `contacts/${id}/edit` }            
            ];
        } 
        return breadcrumbsList;
    }
    const Calldetail = () => {
        addmoreArray = []; addmorEmail = [];let  detailInfo = [];
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getContact.ContactInfo(`/api/contacts/info?contactId=${id}`, accesstoken, (listdata) => {
                    if(listdata.status == 200) {
                        setLoading(false); 
                        setOpen(false)
                        detailInfo.push(listdata.data.data);
                        var datalist = listdata.data.data;
                        SetFirstname(datalist.firstName);
                        SetLastname(datalist.firstName)
                        detailsApi(listdata.data.data);
                    } else if(listdata.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
        const breadcrumbsList = getBreadcrumbs();
        dispatch(parseBreadcrumbsList(breadcrumbsList));
    }
    const Callcreate = () => {
        addmoreArray = []; addmorEmail = [];
    }
    // const handleCityDropdown = () => {
    //     const countryCode = 'US';
    //     const citys = City.getCitiesOfState(countryCode,Iso);
    //     dropdownlistcitys = citys;
    //     console.log(dropdownlistcitys, citys)
    //     setDropdownlistcity(dropdownlistcitys);
    //     setDropdownCliked4(!countryCodeDropdownClick4)

    // }
    const getCityCode = (e, stateCode) => {
        let label = document.getElementsByClassName('dropdown-label-code')
        if(label) {
            label[0].innerText = e.target.innerText
        }
        // var zipCod = zipcodes.lookupByName(e.target.innerText, stateCode);
        // console.log(zipCod);
        var Zipcode = ''
        // if(zipCod.length > 0) {
        //     Zipcode = zipCod[0].zip
        // }
        var zipCode = Zipcode ? Zipcode: ''
        SetZipCode(zipCode)
        setValues({
            ...values,
            ZipCode: Zipcode ? Zipcode: ''
        })
        setDropdownCliked4(!countryCodeDropdownClick4)

    }
    let createNewValues = {
        page: "create-project",
    }
    let editValues = {       
         page: "edit-project",
    }
    useEffect(() => {
        if(entityId) {
            console.log("entity", entityId,entityList)
            setEntityId(entityId)
            entityList.map((data) => {
                console.log("entity", entityId)
                if(data.id == entityId) {
                    setEntityLabel(data.name);
                    console.log("entity", entityId)
                }
            })
        }
        else {
            console.log("entity", entityId)
            setEntityId(null)
            setEntityLabel('Select Property')
        }
        
    }, [entityList])

    useEffect(() => {
        const path = window.location.href;
        const pathSplit = path.split('/');
        const id = parseInt(pathSplit[pathSplit.length - 2]);
        const pageType = pathSplit[pathSplit.length - 1];
        if(pageType == "new") {
            const label = 'Select City'
            let labeling = document.getElementsByClassName('dropdown-label-code')
            // if(labeling) {
            //     labeling[0].innerText = label
            // }
            SetZipCode('')
        }
    }, [stateLabel])

    useEffect(() => {
        var params = "";
        const path = window.location.href;
        const pathSplit = path.split('/');
        const id = parseInt(pathSplit[pathSplit.length - 2]);
        const pageType = pathSplit[pathSplit.length - 1];
        if(pageType == "new") {
            StoreValue =  createNewValues;            
            setSave(true)
        } else if(pageType == "edit") {
            StoreValue = editValues;       
        } 
        else if(pageType == "view") {
            StoreValue = editValues;
            setshow(true)
        }
        GetDropdown();
        // GetDropdowncity();
        GetDropdownstate();
        getCountryCodeArray();
        getSaluatiion();
        if(StoreValue.page == "create-project") {
            Callcreate();
            const breadcrumbsList = getBreadcrumbs();
            dispatch(parseBreadcrumbsList(breadcrumbsList));
        } 
        else {
            Calldetail();
        } 
    },[])

    const GetEntities = (property) => {
        if(property.name == "All") {
            var entityArray = [];
            selectedEntityList.length > 0 && selectedEntityList.map((item) => {
                if(item.id != 0) {
                    const entityObject = {idContactsEntityRelation: 0, idEntities: null, name: "", relationship: null}
                    entityObject.idEntities = item.id;
                    entityObject.name = item.name;
                    entityObject.relationship = property.relationship ? property.relationship : null;
                    entityArray.push(entityObject);
                }
            })
            setPropertyDetails(entityArray);
        } else {
            var isPresent = false;
            if(property.name != null && property.name != "") {
                if(propertyDetails.length > 0) {
                    propertyDetails.map((item) => {
                        if(item.name == property.name) {
                            isPresent = true;
                        }
                    })
                } else {
                    setPropertyDetails([...propertyDetails, property])
                }
            }

            if(!isPresent) {
                setPropertyDetails([...propertyDetails, property])
            } else {
                var updatedPropertyDetails = propertyDetails.map(item => {
                    if(item.name == property.name) {
                        return { ...item, relationship: property.relationship }
                    } else {
                        return item;
                    }
                });
                setPropertyDetails(updatedPropertyDetails);
            }
        }
    }

    const handlePropertyDelete = (index) => {
        setDeletedPropertyIndex(index);
        handleShowDeletePropertyPopup();
    }

    const deleteProperty = () => {
        propertyDetails.splice(deletedPropertyIndex, 1);
        setPropertyDetails([...propertyDetails]);
        handleCloseDeletePropertyPopup();
    }

    const handleBrandDropdown = (id) => {
        setBrandId(id);
        if(id != brandId) {
            setPropertyDetails([]);
        }
    }

    useEffect(() => {
        if(brandId != null && entityList.length > 0) {
            var entityArray = [];
            entityList.length > 0 && entityList.map((item) => {
                if(item.brandId == brandId || item.parentBrand == brandId) {
                    const entityObject = {id: 0, name: ''}
                    entityObject.id = item["idEntities"];
                    entityObject.name = item["entityName"];
                    entityArray.push(entityObject);
                }
            })
            var allArray = [];
            if(entityArray.length > 0) {
                const entityAllObject = {id: 0, name: 'All'}
                allArray.push(entityAllObject);
            }
            setSelectedEntityList([...allArray, ...entityArray]);
        }
    }, [brandId, entityList]);

    const handlePasswordShow = () => {
        setShowPassword(!showPassword);
    }

    return(
        <>
            <div className='new-contact-create-container'>
                {console.log("Selected properties [RENDER]", propertyDetails)}
                <Header />
                <div className='row new-contact-sub-container'>
                    <Sidebar />
                    <div className='col-10 create-new-body-container'>
                        <div className='sub-header'>
                            <Breadcrumbs/>
                            {isLoading ?
                                (<Spinner/>) :
                            (<div>
                                <div className='edit-project-content'>
                                    <div className='row gx-10 label-input-row sub-section1'>
                                        <div className='col-4 label-input-col'>
                                            <div className='label-input label-input-name'>
                                                <label className="required">First Name</label>
                                                <div className="dropdown-salutation-container">
                                                    <div className="dropdown-salutation">
                                                       <Dropdown selectedItem={(name, id) => setSaluation(name)}  label={saluationlabel}  handleLabel={(value) => setSaluationLabel(value)} list={salutaionList} enable={true}/>
                                                    </div>
                                                    <div> 
                                                        <input className='input-box' type="text" value={Firstname} onChange={(e) => handleFname(e.target.value)} maxLength={45}></input>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-4 label-input-col'>
                                            <div className='label-input label-input-name'>
                                                <label>Last Name</label>
                                                <div className='input-box'> 
                                                    <input type="text" value={Lastname} onChange={(e) => handleLname(e.target.value)} maxLength={45}></input>
                                                </div>                                            
                                            </div>
                                        </div>
                                        <div className='col-4 label-input-col'>
                                            <div className='label-input label-input-name'>
                                                <label>Title</label>
                                                <div className='input-box'> 
                                                    <input type="text" value={title} onChange={(e) => handleTitle(e.target.value)} maxLength={100}></input>
                                                </div>                                            
                                            </div>
                                        </div>
                                        <div className='col-4 label-input-col'>
                                            <div className='label-input label-input-entity'>
                                                <label className='required'>Portal</label>
                                                <Dropdown label={brandLabel} selectedItem={(name, id) => handleBrandDropdown(id)}
                                                    handleLabel={(value) => setBrandLabel(value)} list={brandList} enable={true}/>
                                            </div>
                                        </div>
                                        <div className='col-4 label-input-col'>
                                            <div className='label-input label-input-name'>
                                                <label>Franchise Category</label>
                                                <div className='input-box'> 
                                                    <input type="text" value={franchise} onChange={(e) => handleFranchise(e.target.value)} maxLength={100}></input>
                                                </div>                                            
                                            </div>
                                        </div>
                                        <div className='col-4 label-input-col'>
                                            <div className='label-input label-input-name'>
                                            <div className='password-field'>
                                                <div className='label label-color'>Password</div>
                                                <div className='password-input-field'>
                                                    <input className='input-field' type={showPassword ? "text" : "password"} onChange={(e) => handlePassword(e.target.value)} maxLength={20}/>
                                                    <img src={eyeIcon} alt="eye-icon" onClick={handlePasswordShow}></img>
                                                </div>
                                            </div>                                            
                                            </div>
                                        </div>
                                        <div className='property-body'>
                                            <div className='property-header'>
                                                <div><img src={add} alt='add' onClick={() => handleProperties("add")}></img></div>
                                            </div>
                                            <div className='table-view-container'>
                                                <div className='list-items'>
                                                    <table>
                                                        <thead>
                                                            <tr className='heading-row'>
                                                                {tableHeaders != null && tableHeaders.map((item, index) => {
                                                                    return (
                                                                        <>
                                                                            <th className={`${'heading-data'+index}`} style={{ minWidth: `${item.width}` }}>
                                                                                <div className='flex-display'>
                                                                                    <div className='table-header-label'>{item.name}</div>  
                                                                                </div>                                  
                                                                            </th>
                                                                        </>
                                                                    )
                                                                })}
                                                            </tr>
                                                        </thead>
                                                        {
                                                            propertyDetails && propertyDetails.length === 0 ? <p className="no-result">No results found</p> :
                                                            <tbody>
                                                                {propertyDetails != null && propertyDetails.map((item, index) => {
                                                                    return (
                                                                        <tr>
                                                                            {console.log("Property Details", item)}
                                                                            <td className='task-data1'>{item.name}</td>
                                                                            <td className='task-data2'>{item.relationship}</td>
                                                                            {<td className='task-data3'>
                                                                                <div className='actions'>
                                                                                    <img id={`${'edit'+index}`} className='edit' src={edit} alt="edit" onClick={() => handleProperties("edit", item)}></img>
                                                                                    <img id={`${'trash'+index}`} className='trash' src={trash} alt="delete" onClick={() => handlePropertyDelete(index)}></img>
                                                                                </div>
                                                                            </td>}
                                                                        </tr>
                                                                    )
                                                                })}
                                                            </tbody>
                                                        }
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Showing Add Entity popup */}
                                        <AddContact show={showContacts} handleClose={handleCloseContacts} getEntityDetails={GetEntities} selectedEntityList={selectedEntityList}
                                        entityDetails={entityDetails} setEntityDetails={setEntityDetails} propertyLabel={propertyLabel}
                                        setPropertyLabel={setPropertyLabel} error={error} setError={setError}/>
                                    </div>
                                    <hr />
                                    <div className='row gx-10 label-input-row sub-section4'>
                                        <div className='col-4 label-input-col'>
                                            <div className='label-input label-input-name'>
                                                <label>Primary Phone</label>
                                                <div className='calling-country-code'> 
                                                    <div className="calling-code-flex">
                                                        <div className='dropdown dropdown-country-code-container' ref={dropdownwrapperRef1}>
                                                            <div className='dropdown-country-code'>
                                                                <input className='calling-code input-box' value={countryCode1} onChange={(e) => getCountryCode1(e.target.value)}/>
                                                            </div>
                                                            {countryCodeDropdownClick1 &&
                                                                <div className='dropdown-list'>
                                                                    {
                                                                        callingCodeSuggestions.length > 0 && callingCodeSuggestions.map((item, index) => {
                                                                            return (
                                                                                <div className='dropdown-content-inner countrycode-dropdown-inner' key={index} 
                                                                                onClick={(event) => getCountryCode1FromSelection(event.target.innerText)}>{item}</div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            }
                                                        </div>
                                                        <div>
                                                            <input className="input-box phone-number" type="text" value={phone1} 
                                                            onChange={(e) => setPhoneNumbers1(e.target.value)} maxLength={15}></input>
                                                        </div>
                                                    </div>
                                                </div>    
                                            </div>                      
                                        </div>
                                        <div className='col-4 label-input-col'>
                                            <div className='label-input label-input-name'>
                                                <label>Secondary Phone 1</label>
                                                <div className='calling-country-code'> 
                                                    <div  className="calling-code-flex">
                                                        <div className='dropdown dropdown-country-code-container'  ref={dropdownwrapperRef2}>
                                                            <div className='dropdown-country-code'>
                                                                <input className='calling-code input-box' value={countryCode2} onChange={(e) => getCountryCode2(e.target.value)}/>
                                                            </div>
                                                            {countryCodeDropdownClick2 &&
                                                                <div className='dropdown-list'>
                                                                    {
                                                                        callingCodeSuggestions.length > 0 && callingCodeSuggestions.map((item, index) => {
                                                                            return (
                                                                                <div className='dropdown-content-inner countrycode-dropdown-inner' key={index} 
                                                                                onClick={(event) => getCountryCode2FromSelection(event.target.innerText)}>{item}</div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            }
                                                        </div>
                                                        <div>
                                                            <input className="input-box phone-number" type="text" value={phone2} 
                                                            onChange={(e) => setPhoneNumbers2(e.target.value)} maxLength={15}></input>
                                                        </div>
                                                    </div>
                                                </div>         
                                            </div>                                  
                                        </div>
                                        <div className='col-4 label-input-col'>
                                            <div className='label-input label-input-name'>
                                                <label>Secondary Phone 2</label>
                                                <div className='calling-country-code'> 
                                                    <div className="calling-code-flex">
                                                        <div className='dropdown dropdown-country-code-container' ref={dropdownwrapperRef3}>
                                                            <div className='dropdown-country-code'>
                                                                <input className='calling-code input-box' value={countryCode3} onChange={(e) => getCountryCode3(e.target.value)}/>
                                                            </div>
                                                            {countryCodeDropdownClick3 &&
                                                                <div className='dropdown-list'>
                                                                    {
                                                                        callingCodeSuggestions.length > 0 && callingCodeSuggestions.map((item, index) => {
                                                                            return (
                                                                                <div className='dropdown-content-inner countrycode-dropdown-inner' key={index} 
                                                                                onClick={(event) => getCountryCode3FromSelection(event.target.innerText)}>{item}</div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            }
                                                        </div>
                                                        <div>
                                                            <input className="input-box phone-number" type="text" value={phone3} 
                                                            onChange={(e) => setPhoneNumbers3(e.target.value)} maxLength={15}></input>
                                                        </div>
                                                    </div>
                                                </div>      
                                            </div>                                   
                                        </div>
                                    </div>
                                    <div className='row gx-10 sub-section4 phone-contact'>
                                    {
                                        addmoreArray.map((element,index)=>{
                                            return (
                                                <div className='col-4 label-input-col' id={element}>
                                                    <div className='label-input label-input-name'>
                                                        <label>Secondary Phone {index+3}</label>
                                                            <div className='calling-country-code'> 
                                                            <div className="calling-code-flex">
                                                                <div className='dropdown dropdown-country-code-container' ref={dropdownwrapperRef}>
                                                                    <div className='dropdown-name-img dropdown-country-code' onClick={()=>handleCountryCodeDropdown(element)}>
                                                                        <div className='dropdown-name dropdown-label' id={'dropdown-label'+element}>+1</div>
                                                                        <div className="country-arrow"><img id={'dropdown-image'+element} className='arrow' src={downArrow} alt=""></img></div>
                                                                    </div>
                                                                    
                                                                        <div id={'dropdown-lists'+element} className='dropdown-list dropdown-listing'>
                                                                            {
                                                                                callingCodes.length > 0 && callingCodes.map((item, index) => {
                                                                                    return (
                                                                                        <div className='dropdown-content-inner countrycode-dropdown-inner' key={index} 
                                                                                        onClick={(event) => getCountryCode(event,element)}>{item}</div>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </div>    
                                                                </div>
                                                                <div>
                                                                    <input id={'dropdown-input'+element} className="input-box" type="text"  onChange={(e) => setPhoneNumber(e.target.value,element)}></input>
                                                                </div>
                                                            </div>
                                                            </div>  
                                                    </div>
                                                    </div>
                                                    )
                                                    })
                                                }
                                    </div>
                                    {/* <div className='row' ><p onClick={add_fields} className='add-more col-2'>Add More</p></div> */}
                                    <hr />
                                    <div className='row gx-10 label-input-row'>
                                        <div className='col-4 label-input-col'>
                                            <div className='label-input label-input-name'>
                                                <label className="required">Primary Email ID</label>
                                                <div className='input-box'> 
                                                    <input type="email" name="email" value={emailID1} onChange={(e) => changeEmail1(e.target.value)}
                                                    maxLength={100}></input>
                                                </div>     
                                            </div>                                    
                                        </div>
                                        <div className='col-4 label-input-col'>
                                            <div className='label-input label-input-name'>
                                                <label>Secondary Email ID 1</label>
                                                <div className='input-box'> 
                                                    <input type="email" name="email" value={emailID2} onChange={(e) => changeEmail2(e.target.value)}
                                                    maxLength={100}></input>
                                                </div>              
                                            </div>                           
                                        </div>
                                        <div className='col-4 label-input-col'>
                                            <div className='label-input label-input-name'>
                                                <label>Secondary Email ID 2</label>
                                                <div className='input-box'> 
                                                    <input type="email" name="email" value={emailID3} onChange={(e) => changeEmail3(e.target.value)}
                                                    maxLength={100}></input>
                                                </div>       
                                            </div>                                  
                                        </div>
                                    </div>
                                    <div className='row  mail-contact'>
                                    {
                                        addmorEmail.map((element, index) => {
                                            return(
                                            <div className='col-4 label-input-col'>
                                                <div className='label-input label-input-name'>
                                                    <label>Secondary Email ID {index+3}</label>
                                                    <div className='input-box'> 
                                                        <input id={'email-input'+element} type="text"   onChange={(e) => changeEmail(e.target.value,element)}></input>
                                                    </div>     
                                                </div>                                    
                                            </div>
                                            )
                                        })
                                    }
                                    </div>
                                    {/* <div className='row'><p onClick={add_more} className='add-more col-2'>Add More</p></div> */}
                                    <hr />
                                    <div className='row gx-10 label-input-row'>
                                        <div className='col-6'>
                                            <div className='label-input label-input-name address'>
                                                <label>Address</label>
                                                <div className='input-box'> 
                                                    <input type="text" value={Address} onChange={(e) => handlAddress(e.target.value)}
                                                    maxLength={100}></input>
                                                </div>    
                                            </div>                                     
                                        </div>
                                    </div>
                                    <div className='row gx-10 label-input-row'>
                                        <div className='col-4 label-input-col'>
                                            <div className='label-input label-input-name'>
                                                <label>City</label>
                                                <div className='input-box'> 
                                                    <input type="text" value={cityname} onChange={(e) => handleCity(e.target.value)}
                                                    maxLength={100}></input>
                                                </div>            
                                            </div>                            
                                        </div>
                                        <div className='col-4 label-input-col'>
                                            <div className='label-input label-input-name'>
                                                <label>State / Province</label>
                                                <div className='city-dropdown'> 
                                                    <CityStatedropdown selectedItem={(name) => SetState(name)} handleLabel={(value) => setStateLabel(value)} list={dropdownliststate} label={stateLabel}/>
                                                </div>                  
                                            </div>                       
                                        </div>
                                        <div className='col-4 label-input-col'>
                                            <div className='label-input label-input-name'>
                                                <label>Zip / Postal Code</label>
                                                <div className='input-box'> 
                                                    <input maxLength={19} type="text" value={ZipCode} onChange={(e) => handlZipcode(e.target.value)}></input>
                                                </div>              
                                            </div>                           
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="save-button">
                                    {!showEdit ? 
                                        (<button disabled={enable ? false : true} className={enable ? 'save-text-button enable' : 'save-text-button disable'} onClick={onSave}>Save</button>)
                                        :
                                        (<button disabled={enable ? false : true} className={enable ? 'save-edit-button enable' : 'save-edit-button disable'} onClick={onSave}>Save</button>)
                                    }
                                    <Snackbars error={errorMessage} open={open} setOpen={setOpen}/>
                                    </div>
                                </div>
                            </div>)}
                        </div>
                    </div>
                </div>
                <Footer/>

                {/* Showing delete popup */}
                <DeleteItem show={showDeletePopup} handleClose={handleCloseDeletePropertyPopup} deleteApiCall={deleteProperty} enable={true}/>
            </div>
        </>
    )
}

export default CreateNewcontact;